const TermsConditions = () => {
  return (
    <main className="min-h-screen py-20 bg-dark-black">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Terms & Conditions
          </h1>
          <p className="text-gray-400 mb-8">
            Last updated: 02.12.2025
          </p>
          
          <div className="prose prose-invert max-w-none space-y-6 text-gray-300 leading-relaxed">
            <p className="text-xl text-gray-200">
              These Terms and Conditions govern your use of the Empire Wager website (empire-wagers.com). By accessing or using our website, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access the website.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Acceptance of Terms</h2>
            <p>
              By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms and Conditions on this page and updating the "Last updated" date. Your continued use of the website after any such changes constitutes your acceptance of the new Terms and Conditions.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Use License</h2>
            <p>
              Permission is granted to temporarily access the materials on Empire Wager's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
            <p>
              This license shall automatically terminate if you violate any of these restrictions and may be terminated by Empire Wager at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Age Restrictions</h2>
            <p>
              This website is intended for users who are 18 years of age or older. By using this website, you represent and warrant that you are at least 18 years old. We do not knowingly collect information from individuals under 18 years of age.
            </p>
            <p>
              If you are under 18, you must not use this website or provide any personal information to us. If we become aware that we have collected information from someone under 18, we will take steps to delete that information immediately.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Website Content</h2>
            <p>
              The content on this website is provided for informational purposes only. We strive to provide accurate and up-to-date information, but we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the website or the information contained on it.
            </p>
            <p>
              All content, including but not limited to text, graphics, logos, images, and software, is the property of Empire Wager or its content suppliers and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, modify, create derivative works of, publicly display, or otherwise use any content without our prior written permission.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Third-Party Links</h2>
            <p>
              Our website contains links to third-party websites, including online casinos and gambling operators. These links are provided for your convenience and information only. We do not endorse or assume responsibility for the content, privacy policies, or practices of any third-party sites.
            </p>
            <p>
              When you click on links to third-party websites, you will be subject to their terms and conditions and privacy policies. We encourage you to review the terms and privacy policies of any third-party sites you visit.
            </p>
            <p>
              We may receive compensation when you click on links to third-party websites or sign up for services through our affiliate partnerships. This compensation does not influence our editorial content, reviews, or ratings.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Affiliate Relationships</h2>
            <p>
              Empire Wager operates as an independent review and comparison site. Some of the links on our website are affiliate links, meaning we may receive a commission if you click through or sign up through these links. This commercial relationship does not influence our opinions, reviews, or ratings.
            </p>
            <p>
              We maintain editorial independence and provide honest, unbiased reviews regardless of affiliate relationships. Our recommendations are based on our independent analysis and testing, not on potential commissions.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">User Conduct</h2>
            <p>
              You agree to use the website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website. Prohibited behavior includes:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Harassing, threatening, or abusing other users</li>
              <li>Posting false, misleading, or defamatory content</li>
              <li>Violating any applicable laws or regulations</li>
              <li>Transmitting viruses or malicious code</li>
              <li>Attempting to gain unauthorized access to our systems</li>
              <li>Interfering with or disrupting the website or servers</li>
            </ul>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Disclaimer</h2>
            <p>
              The information on this website is provided on an "as is" basis. To the fullest extent permitted by law, Empire Wager excludes all representations, warranties, conditions, and terms relating to our website and the use of this website.
            </p>
            <p>
              We do not warrant that the website will be available at all times or that it will be free from errors, viruses, or other harmful components. We are not responsible for any loss or damage arising from your use of the website or reliance on information contained on it.
            </p>
            <p>
              We are not a gambling operator and do not provide gambling services. We are an independent review and comparison site. Any gambling activities are conducted through third-party operators, and we are not responsible for any losses or issues arising from such activities.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Limitation of Liability</h2>
            <p>
              In no event shall Empire Wager, its directors, employees, or agents be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the website.
            </p>
            <p>
              Our total liability to you for all claims arising from or related to the use of the website shall not exceed the amount you paid to us, if any, for accessing the website, or £100, whichever is greater.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless Empire Wager and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable legal fees, arising out of or in any way connected with your access to or use of the website or your violation of these Terms and Conditions.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Governing Law</h2>
            <p>
              These Terms and Conditions shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions. Any disputes arising from these terms or your use of the website shall be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Severability</h2>
            <p>
              If any provision of these Terms and Conditions is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that these Terms and Conditions shall otherwise remain in full force and effect.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Entire Agreement</h2>
            <p>
              These Terms and Conditions, together with our Privacy Policy, constitute the entire agreement between you and Empire Wager regarding your use of the website and supersede all prior agreements and understandings.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Contact Information</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us:
            </p>
            <p>
              <strong>Email:</strong> info@empire-wagers.com<br />
              <strong>Phone:</strong> +44 5511 778 569<br />
              <strong>Address:</strong> London, United Kingdom
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TermsConditions;

